import React, { Fragment } from 'react'

import styles from './InstallApp.module.css'
import LinkIcon from './link.svg'
import LinkedIcon from './linked.svg'

import Button from 'Design/components/Button'
import Heading from 'Design/components/Heading'

const InstallApp = ({ name, onInstall, isInstalling = false, isInstalled = false }) => {
  const Icon = isInstalled ? LinkedIcon : LinkIcon

  return (
    <div className={styles.Container}>
      <Icon height='3em' width='3em' />

      {!isInstalled && (
        <Fragment>
          <Heading level={2}>
            You haven't linked your {name} account yet,
            <br />
            click below to begin the process.
          </Heading>
          <Button variant='primary' onClick={onInstall} disabled={isInstalling}>
            Install {name}
          </Button>
        </Fragment>
      )}

      {isInstalled && (
        <Heading level={2}>
          {name} integration was <br />
          successfully created!
        </Heading>
      )}
    </div>
  )
}

export default InstallApp
